import { LitElement, html } from "lit";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { packagePricedetailsStyles } from "js/sharedStyles/packagePricedetails.js";

class WJPackagePricedetails extends LitElement {
  data = null;
  packageTemplate = null;
  static get properties() {
    return {
      cost: {
        type: Object,
      },
    };
  }

  static styles = [packagePricedetailsStyles];

  renderProperty(element) {
    return html`<tr>
      <td>${element.caption.text}</td>
      <td>${element.content.text}</td>
    </tr>`;
  }

    euroDisplay(amount) {
    if (isNaN(amount) && amount.indexOf(",") > -1) {
      amount = amount.replace(/\,/g, ".");
    }

    return unsafeHTML(parseFloat(amount).toFixed(2).replace(".", ",") + "&nbsp;&euro;");
  }

  render() {
    let cost = this.cost;

    let usagePrice;
    if (cost.unitPriceOnPeak) {
      usagePrice = html`${cost.unitPriceOnPeak.content.text} (Hauptzeit) <br />
        ${cost.unitPriceOffPeak.content.text} (Nebenzeit)`;
    } else if (cost.unitPrice) {
      usagePrice = html`${cost.unitPrice.content.text}`;
    }
    let totalPriceWithoutBonus = (parseFloat(cost.usageCosts.amount.replace(/\,/g, ".")) + parseFloat(cost.fixedCosts.amount.replace(/\,/g, "."))).toFixed(2);

    let totalMonthlyPriceWithoutBonus = (totalPriceWithoutBonus / 12).toFixed(2);

    let bonusItems = cost.totalCost.totalCostItems.filter((item) => item.caption.text.toLowerCase().indexOf("bonus") > -1);

    let bonusItemsHtml = bonusItems.map((item) => {
      return html`
      <div class="layout__item u-7/24(!s) u-10/24(s) mb--">
        <span class="u-text-color-status--green">${item.caption.text}</span>
      </div>
      <div class="layout__item u-7/24(!s) u-10/24(s) u-text-color-status--green">${item.content.text}</div>
      <div class="layout__item u-10/24 u-display--none(s)"></div>`;
    });

    return html`<h5 class="mb-">Informationen zum Preis</h5>
      <div class="layout">
        <div class="layout__item u-7/24(!s) u-10/24(s) mb--">${cost.usageCosts.caption.text}</div>
        <div class="layout__item u-7/24">${cost.usageCosts.content.text}</div>
        <div class="layout__item u-10/24(!s) u-7/24(s)">${usagePrice}</div>
        <div class="layout__item u-7/24(!s) u-10/24(s) mb--">${cost.fixedCosts.caption.text}</div>
        <div class="layout__item u-7/24">${cost.fixedCosts.content.text}</div>
        <div class="layout__item u-10/24(!s) u-7/24(s)">entspricht ${cost.totalCost.totalCostItems[1].content.text}</div>
        <div class="layout__item u-7/24(!s) u-10/24(s) mb--">Gesamtpreis ohne Bonus</div>
        <div class="layout__item u-7/24">${this.euroDisplay(totalPriceWithoutBonus)}</div>
        <div class="layout__item u-10/24(!s) u-7/24(s)">${this.euroDisplay(totalMonthlyPriceWithoutBonus)} pro Monat</div>
        ${bonusItemsHtml}
        <div class="layout__item u-7/24(!s) u-10/24(s) mt u-font-weight--bold">
        <span>${cost.totalCost.caption.text}</span>
        <bc-tooltip data-trigger-style="dashed"> ${unsafeHTML(cost.totalCost.content.tooltip.body)} </bc-tooltip>
        </div>
        <div class="layout__item u-7/24(!s) u-14/24(s) u-font-weight--bold pt- mt- u-border--top">${cost.totalCost.content.text}</div>
        <div class="layout__item u-10/24"></div>
      </div>
      <div class="mt u-size-s">Die Preisangaben für Haushaltskunden enthalten alle notwendigen Gebühren und steuerlichen Abgaben. Die Preisangaben für Gewerbekunden sind exklusive Mehrwertsteuer. Beachten Sie, dass sich alle Berechnungen auf das erste Vertragsjahr beziehen. Die Boni sind in den geschätzten Abschlag noch nicht mit einberechnet. Der Sofortbonus wird innerhalb von 60 Tagen überwiesen. Der Neukundenbonus wird am Ende des ersten Vertragsjahres gutgeschrieben oder ausgezahlt.</div>`;
  }
}

const initWJPackagePricedetails = () => {
  window.customElements.define("wj-package-pricedetails", WJPackagePricedetails);
};
export { initWJPackagePricedetails };
